var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#EDF0F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F6F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7915 11.717V13.6065C6.7915 13.8092 6.711 14.0035 6.56771 14.1468C5.97092 14.7436 5.97092 15.7112 6.56771 16.3079L7.37317 17.1134C8.13249 17.8727 9.36361 17.8727 10.1229 17.1134L11.072 16.1643C11.2544 15.982 11.5016 15.8796 11.7595 15.8796H14.4003C14.8806 15.8796 15.2699 15.4902 15.2699 15.01C15.2699 14.7698 15.4646 14.5752 15.7047 14.5752C16.1849 14.5752 16.5743 14.1859 16.5743 13.7056C16.5743 13.4655 16.7689 13.2708 17.009 13.2708C17.4893 13.2708 17.8786 12.8815 17.8786 12.4012V11.5814H12.5715C12.3299 11.5814 12.134 11.7773 12.134 12.0189V12.0812C12.134 12.9135 11.4593 13.5881 10.6271 13.5881H9.7204C8.88817 13.5881 8.21351 12.9135 8.21351 12.0812V9.89226L7.07625 11.0295C6.89393 11.2118 6.7915 11.4591 6.7915 11.717ZM9.28292 8.82285V12.0812C9.28292 12.3228 9.47878 12.5187 9.7204 12.5187H10.6271C10.8687 12.5187 11.0646 12.3228 11.0646 12.0812V12.0189C11.0646 11.1867 11.7393 10.512 12.5715 10.512H16.7243L17.1559 10.0804C17.9153 9.32109 17.9153 8.08997 17.1559 7.33065L16.6448 6.8195C15.8854 6.06017 14.6543 6.06017 13.895 6.8195L13.5981 7.11642C13.4158 7.29874 13.1685 7.40116 12.9106 7.40116H10.7046C9.98422 7.40116 9.40023 7.98515 9.40023 8.70553L9.28292 8.82285Z",
    fill: "#898EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealRound);
export default __webpack_public_path__ + "static/media/dealRound.00cfc9879156f785c9307fdd9a4144d5.svg";
export { ForwardRef as ReactComponent };